import React from "react";

const NotFoundPage = (): JSX.Element => (
    <div className="margin-v2">
        <h1 className="text text-l">404 - nieznana strona :(</h1>
    </div>
);

export default NotFoundPage;
